import {
  PlayerSummary,
  GetCountByIntervalResponse,
  Location,
  Granularity,
  CustomerAtmUseSummary,
} from '@inplay/models'; // Adjust according to your models location
import { isApiError } from '../utils/helper';
import { getEnvironmentVariable } from '../helper/config';
import { EnvVariables } from '../utils/helper.type';
import axiosClient from '../utils/apiClient';
import apiClient from '../utils/apiClient';
import moment, { Moment } from 'moment';
import { AxiosResponse } from 'axios';

export class PlayerService {
  private baseApi: string;

  constructor() {
    const baseURL: string | undefined = axiosClient.defaults.baseURL;

    if (!baseURL) {
      throw new Error('baseURL is not defined in axiosClient.');
    }

    this.baseApi = baseURL;
  }

  public async getPlayerSummaries(
    venueBranchIds: string[],
    startTime: number | undefined,
    endTime: number | undefined,
    playerPageNumber: number,
    limit: number,
    onlyCurrentPlayers: boolean,
  ): Promise<PlayerSummary[]> {
    try {
      console.log(`[PlayerService][getPlayerVisitsSummary][ENTRY]`, {
        venueBranchIds,
        startTime,
        endTime,
        playerPageNumber,
        limit,
        onlyCurrentPlayers,
      });

      const today: Moment = moment().startOf('day');
      const startTimestamp: number | undefined = startTime
        ? Number(startTime)
        : undefined;
      const endTimestamp: number | undefined = endTime
        ? Number(endTime)
        : undefined;
      const isStartToday: boolean = startTimestamp
        ? moment.unix(startTimestamp).isSame(today, 'day')
        : false;
      const isEndToday: boolean = endTimestamp
        ? moment.unix(endTimestamp).isSame(today, 'day')
        : false;
      const params: Record<string, number | string | undefined> = {};
      if (!isStartToday && startTimestamp) params.startTime = startTimestamp;
      if (!isEndToday && endTimestamp) params.endTime = endTimestamp;
      params.limit = limit;
      params.page = playerPageNumber;
      params.venueBranchIds = venueBranchIds[0];
      params.onlyCurrentPlayers = onlyCurrentPlayers ? 'true' : 'false';

      const playerSummaryApiResource: string = getEnvironmentVariable(
        EnvVariables.REACT_APP_PLAYER_VISITS_API_RESOURCE,
      );

      const playerSummaryApiEndpoint: string = `${this.baseApi}${playerSummaryApiResource}`;

      const playersSummaryApiResponse: AxiosResponse<PlayerSummary[]> =
        await apiClient.get(playerSummaryApiEndpoint, { params });
      console.log(`[PlayerService][getPlayerSummary]`, {
        playersSummaryApiResponse,
      });
      const playerSummary: PlayerSummary[] = playersSummaryApiResponse.data;
      return playerSummary;
    } catch (error: unknown) {
      console.error(`[PlayerService][getPlayerSummary][ERROR]`, {
        error,
      });
      if (isApiError(error)) {
        throw error;
      }

      throw error;
    }
  }

  public async countPlayersByInterval(
    startTime?: string,
    endTime?: string,
    location?: Location,
    granularity?: Granularity,
  ): Promise<GetCountByIntervalResponse> {
    try {
      console.log(`[PlayerService][fetchHourlyData][ENTRY]`, {
        startTime,
        endTime,
        location,
        granularity,
      });

      const hourlyDataApiResource: string = getEnvironmentVariable(
        EnvVariables.REACT_APP_HOURLY_API_RESOURCE,
      );
      const hourlyDataApiEndpoint: string = `${this.baseApi}${hourlyDataApiResource}`;

      const hourlyApiResponse: AxiosResponse<GetCountByIntervalResponse> =
        await apiClient.get(hourlyDataApiEndpoint, {
          params: { startTime, endTime, location, granularity },
        });

      console.log(`[PlayerService][fetchHourlyData][RESPONSE]`, {
        hourlyApiResponse,
      });

      const houlryData: GetCountByIntervalResponse = hourlyApiResponse.data;
      return houlryData;
    } catch (error: unknown) {
      console.error(`[PlayerService][fetchHourlyData][ERROR]`, {
        error,
      });

      if (isApiError(error)) {
        throw error;
      }

      throw error;
    }
  }

  public async getAtmUsers(
    startTime: number,
    endTime: number,
  ): Promise<CustomerAtmUseSummary[]> {
    try {
      console.log(`[PlayerService][getAtmUsers][ENTRY]`, {
        startTime,
        endTime,
      });

      const atmUserApiResource: string = getEnvironmentVariable(
        EnvVariables.REACT_APP_ATM_USER_API_RESOURCE,
      );

      const atmUsersApiEndpoint: string = `${this.baseApi}${atmUserApiResource}`;

      const atmUsersApiResponse: AxiosResponse<CustomerAtmUseSummary[]> =
        await apiClient.get(atmUsersApiEndpoint, {
          params: { startTime, endTime },
        });
      console.log(`[PlayerService][getAtmUsers]`, {
        atmUsersApiResponse,
      });
      const atmUsers: CustomerAtmUseSummary[] = atmUsersApiResponse.data;
      return atmUsers;
    } catch (error: unknown) {
      console.error(`[PlayerService][getAtmUsers][ERROR]`, {
        error,
      });
      if (isApiError(error)) {
        throw error;
      }

      throw error;
    }
  }
}
